module.exports = __webpack_public_path__ + "img/1098071434.9947091b.jpg";